function initBundleX4() {
  const addButton = document.getElementById('bundle-x4-add-to-cart');
  const feedback = document.getElementById('bundle-x4-feedback');
  const selects = document.querySelectorAll('.bundle-x4__slot-select');

  if (!addButton || addButton.dataset.bundleInitialized) {
    return;
  }
  addButton.dataset.bundleInitialized = 'true';

  selects.forEach(function (select) {
    select.addEventListener('change', function () {
      const slot = select.closest('.bundle-x4__slot');
      const img = slot ? slot.querySelector('.bundle-x4__slot-image img') : null;
      const selectedOption = select.options[select.selectedIndex];
      if (img && selectedOption.dataset.image) {
        img.src = selectedOption.dataset.image;
        img.alt = selectedOption.dataset.title || '';
      }
    });
  });

  const toggleButton = document.getElementById('bundle-x4-personalize-toggle');
  const slotsBlock = document.getElementById('bundle-x4-slots');

  if (toggleButton && slotsBlock && !toggleButton.dataset.toggleInitialized) {
    toggleButton.dataset.toggleInitialized = 'true';
    toggleButton.addEventListener('click', function () {
      const isHidden = slotsBlock.hasAttribute('hidden');
      if (isHidden) {
        slotsBlock.removeAttribute('hidden');
        toggleButton.textContent = 'Masquer la personnalisation';
      } else {
        slotsBlock.setAttribute('hidden', '');
        toggleButton.textContent = 'Personnaliser les couleurs';
      }
    });
  }

  selects.forEach(function (select) {
    const index = select.dataset.slotIndex;
    const circle = document.querySelector('.bundle-x4__circle[data-slot-index="' + index + '"]');
    if (circle && !select.dataset.circleSyncInitialized) {
      select.dataset.circleSyncInitialized = 'true';
      select.addEventListener('change', function () {
        const selectedOption = select.options[select.selectedIndex];
        const circleImg = circle.querySelector('img');
        if (circleImg && selectedOption.dataset.image) {
          circleImg.src = selectedOption.dataset.image;
          circleImg.alt = selectedOption.dataset.title || '';
        }
      });
    }
  });

  addButton.addEventListener('click', async function () {
    const items = Array.from(selects).map(function (select) {
      return {
        id: parseInt(select.value, 10),
        quantity: 1
      };
    });

    addButton.disabled = true;
    addButton.textContent = 'Ajout en cours...';

    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');

      const deferredPromise = CartLinesUpdateEvent.createPromise();

      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        cartDrawer.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: items.map(function(item) {
              return {
                merchandiseId: String(item.id),
                quantity: item.quantity,
              };
            }),
            promise: deferredPromise.promise,
          })
        );
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });

      const data = await response.json();

      if (data.status) {
        throw new Error(data.message || 'Erreur lors de l\'ajout');
      }

      deferredPromise.resolve({ didError: false });

      setTimeout(function () {
        const dialog = document.querySelector('cart-drawer-component')?.closest('dialog');
        if (dialog) {
          dialog.setAttribute('cart-summary-sticky', 'true');
        }
      }, 300);

      addButton.textContent = 'Ajouter mon pack au panier';
      addButton.disabled = false;
      feedback.textContent = '✓ Pack ajouté au panier !';
      feedback.hidden = false;

      setTimeout(function () {
        feedback.hidden = true;
      }, 4000);

    } catch (error) {
      console.error('Erreur ajout panier:', error);
      addButton.textContent = 'Ajouter mon pack au panier';
      addButton.disabled = false;
      feedback.textContent = "Erreur : " + error.message;
      feedback.hidden = false;
    }
  });
}

document.addEventListener('DOMContentLoaded', initBundleX4);
document.addEventListener('shopify:section:load', initBundleX4);
setTimeout(initBundleX4, 1000);